import { render, staticRenderFns } from "./Tecnologia.vue?vue&type=template&id=219816be&scoped=true&"
import script from "./Tecnologia.vue?vue&type=script&lang=js&"
export * from "./Tecnologia.vue?vue&type=script&lang=js&"
import style0 from "./Tecnologia.vue?vue&type=style&index=0&id=219816be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219816be",
  null
  
)

export default component.exports